import React, {useEffect, useState} from 'react';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import {useSelector} from "react-redux";
import emojiOptions from "../../helpers/emojiOptions";

export const messageType = {
  success: 'success',
  warning: 'warning',
  info: 'info',
  error: 'error',
};

const RequestAlertBar = () => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('Acknowledged');
  const [severity, setSeverity] = useState(messageType.info);
  const [submittedBy, setSubmittedBy] = useState(null);
  const [submittedAnswer, setSubmittedAnswer] = useState(null);
  const [teammateAction, setTeammateAction] = useState(null);
  const alerts = useSelector((state) => state.ui?.alerts) ?? [];

  useEffect(()=>{
    //if we see alerts fired when they shouldn't be, could add timestamp and check for time or maybe a 'delete alert" here rather than just pushing onto an alert array
    if (alerts.length > 0) {
      const mostRecent = alerts.at(alerts.length-1);
      setMessage(mostRecent.message);
      setSeverity(mostRecent.type);
      setSubmittedBy(mostRecent.submittedBy ?? null);
      setSubmittedAnswer(mostRecent.submittedAnswer ?? null);
      setTeammateAction(mostRecent.teammateAction ?? null);
      setOpen(true)
    }
  },[alerts]);

  const handleClose = () => {
    setOpen(false);
  };

  const alertContent = submittedBy ? (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Avatar sx={submittedBy.color ? { backgroundColor: submittedBy.color } : undefined}>
        {submittedBy.character != null && submittedBy.character >= 0 && emojiOptions[submittedBy.character]
          ? emojiOptions[submittedBy.character]
          : (submittedBy.name?.[0] ?? '?')}
      </Avatar>
      <span>
        {submittedBy.name}
        {(() => {
          if (teammateAction) {
            return ` ${teammateAction}`;
          }
          if (submittedAnswer != null) {
            const incorrectSuffix = severity === messageType.error ? ' (incorrect)' : '';
            return ` answered ${submittedAnswer}${incorrectSuffix}`;
          }
          return '';
        })()}
      </span>
    </Box>
  ) : message;

  return(
    <>
      <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
        <Alert severity={severity} variant="filled" style={{width: '100%'}}>{alertContent}</Alert>
      </Snackbar>
    </>
  )
};

export default RequestAlertBar;